export const reviews = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%20avatar%2C%20casual%20style%2C%20clean%20background%2C%20friendly%20expression%2C%20simple%20profile%20picture&width=80&height=80&seq=review-avatar-01&orientation=squarish',
    role: '资深韩漫读者',
    rating: 5,
    content: '这个网站真的是韩漫爱好者的天堂！漫画种类齐全，更新速度也很快。特别喜欢《我独自升级》，画风精美剧情燃爆，每次更新都第一时间来看！',
    date: '2025-01-15'
  },
  {
    id: 2,
    name: '小樱花',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20avatar%2C%20cute%20style%2C%20clean%20background%2C%20warm%20smile%2C%20simple%20profile%20picture&width=80&height=80&seq=review-avatar-02&orientation=squarish',
    role: '恋爱漫画爱好者',
    rating: 5,
    content: '女神降临和某天成为公主都是我的最爱！这里的阅读体验很棒，页面简洁没有广告干扰。已经推荐给身边所有喜欢看韩漫的朋友了～',
    date: '2025-01-12'
  },
  {
    id: 3,
    name: '剑客无名',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20man%20portrait%20avatar%2C%20serious%20style%2C%20clean%20white%20background%2C%20professional%20look%2C%20simple%20profile%20picture&width=80&height=80&seq=review-avatar-03&orientation=squarish',
    role: '武侠漫画迷',
    rating: 5,
    content: '《剑尊归来》是我近年来看过最好的武侠韩漫！搞笑与热血并存，画风也超级棒。网站的分类也很清晰，找漫画特别方便，收藏功能也很好用。',
    date: '2025-01-10'
  },
  {
    id: 4,
    name: '奇幻旅人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20avatar%2C%20casual%20hoodie%20style%2C%20clean%20background%2C%20thoughtful%20expression%2C%20simple%20profile%20picture&width=80&height=80&seq=review-avatar-04&orientation=squarish',
    role: '奇幻小说读者',
    rating: 4,
    content: '《全知读者视角》的世界观设定太厉害了！每次看都有新发现。这里的漫画资源很丰富，有很多冷门佳作也能找到，推荐大家多探索一下分类。',
    date: '2025-01-08'
  },
  {
    id: 5,
    name: '落日余晖',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20avatar%2C%20minimal%20style%2C%20clean%20white%20background%2C%20calm%20expression%2C%20simple%20profile%20picture&width=80&height=80&seq=review-avatar-05&orientation=squarish',
    role: '宫廷漫画爱好者',
    rating: 5,
    content: '反派千金系列每一部都追！《拯救反派》的剧情真的绝了，反转一个接一个。感谢网站提供了这么全的韩漫资源，每天都在追更新！',
    date: '2025-01-05'
  },
  {
    id: 6,
    name: '深夜读者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20man%20portrait%20avatar%2C%20glasses%20style%2C%20clean%20background%2C%20intellectual%20look%2C%20simple%20profile%20picture&width=80&height=80&seq=review-avatar-06&orientation=squarish',
    role: '漫画收藏家',
    rating: 5,
    content: '收藏和书签功能很实用，看到一半可以无缝继续。漫画更新推送也很及时，已经彻底入坑韩漫了！希望网站能收录更多经典完结漫画，方便补番。',
    date: '2025-01-03'
  }
];

export const stats = [
  { value: '10,000+', label: '漫画资源' },
  { value: '500万+', label: '月活跃用户' },
  { value: '99.7%', label: '好评率' },
  { value: '365天', label: '持续更新' }
];